import { FC } from 'react';
import { Upload } from 'antd';
import ProUpload, { UploadProps } from './upload';

export type IUploadComponent = FC<
  UploadProps & React.RefAttributes<HTMLElement>
> & {
  LIST_IGNORE: string;
};

const TransUpload = ProUpload as IUploadComponent;
TransUpload.LIST_IGNORE = Upload.LIST_IGNORE;

export default TransUpload;

